import jsonp from "jsonp";

const getCnpj = async (cnpj) => {
  return new Promise((resolve, reject) => {
    const apiUrl = `https://www.receitaws.com.br/v1/cnpj/${cnpj}`;
    const options = {
      param: "callback",
      timeout: 5000,
    };

    jsonp(apiUrl, options, (err, data) => {
      if (err) {
        console.error(err);
        reject({ data: null, status: 500, error: err });
      } else {
        resolve({ data, status: 200 });
      }
    });
  });
};

const ReceitaApiClient = { getCnpj };
export default ReceitaApiClient;
